<template>
    <div class="modal" :id="id">
        <div class="modal-content">
            <div class="row">
                <span class="close">&times;</span>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <h3>{{$t('page.management.booking.dest_place')}}</h3>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.management.warehouse.storage.warehouse') }}</label>
                        <div class="col-md-8">
                            <select :id="$id('warehouses')" :ref="$id('warehouses')" class="form-control" @change="selectWarehouse">
                                <option value="-1">{{ $t('page.management.warehouse.storage.warehouse') }}</option>
                                <option v-for="warehouse in warehouses" :value="warehouse.id">{{warehouse.name}}</option>
                            </select>
                        </div>

                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.management.warehouse.storage.storage') }}</label>
                        <div class="col-md-8">
                            <select :id="$id('storages')" :ref="$id('storages')" class="form-control" @change="selectStorage">
                                <option value="-1">{{ $t('page.management.warehouse.storage.storage') }}</option>
                                <option v-for="storage in storages" :value="storage.id">{{storage.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.management.warehouse.storage.storage_rack') }}</label>
                        <div class="col-md-8">
                            <select :id="$id('racks')" :ref="$id('racks')" class="form-control" @change="selectRack">
                                <option value="-1">{{ $t('page.management.warehouse.storage.storage_rack') }}</option>
                                <option v-for="rack in racks" :value="rack.id">{{rack.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.management.warehouse.storage.storage_place') }}</label>
                        <div class="col-md-8">
                            <select :id="$id('places')" :ref="$id('places')" class="form-control">
                                <option value="-1">{{ $t('page.management.warehouse.storage.storage_place') }}</option>
                                <option v-for="place in storagePlaces" :value="place.id">{{place.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="col-md-4 control-label">{{ $t('page.management.warehouse.storage.quantity') }}</label>
                        <div class="col-md-8">
                            <number-input-spinner :ref="$id('quantity')"></number-input-spinner>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-offset-6 col-md-6">
                    <button class="form-control" @click="sendRebook">{{$t('page.management.booking.create_rebooking')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NumberInputSpinner from "../utils/NumberInputSpinner";

    export default {
        name: "RebookModal",
        components: {NumberInputSpinner},
        data: function() {
            return {
                componentKey: 0,
                productId: BigInt,
                storagePlaceId: BigInt,
                maxStock: BigInt,
                warehouses: [],
                storages: [],
                racks: [],
                storagePlaces: [],
            }
        },
        props: {
            id: String,
        },
        mounted(){
            axios.get('/manage/storage/warehouse/', {
                headers: {
                    'X-CSRF-TOKEN': this.csrf
                },
            }).then(function (response) {
                vue.warehouses = [];
                vue.warehouses = response.data;

            }).catch(function (error) {

            });
        },
        methods: {
            setMaxStock: function(maxStock){
              this.maxStock = maxStock;
            },
            setProductId: function(productId){
                this.productId = productId;
            },
            setStoragePlaceId: function(placeId){
                this.storagePlaceId = placeId;
            },
            selectWarehouse: function () {
                let warehouseId = $('#'+ this.$id('warehouses')).val();

                $('.loading-screen').addClass('active');
                axios.get('/manage/storage/warehouse/' + warehouseId + '/storage' , {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf
                    },
                }).then(function (response) {
                    vue.storages = response.data;
                }).finally(function () {
                    $('.loading-screen').removeClass('active');
                });
            },
            selectStorage: function () {
                let warehouseId = $('#'+ this.$id('warehouses')).val();
                let storageId = $('#'+ this.$id('storages')).val();

                $('.loading-screen').addClass('active');
                axios.get('/manage/storage/warehouse/' + warehouseId + '/storage/' + storageId + '/rack', {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf
                    },
                }).then(function (response) {
                    vue.racks = response.data;
                }).finally(function () {
                    $('.loading-screen').removeClass('active');
                });
            },
            selectRack: function () {
                let warehouseId = $('#'+ this.$id('warehouses')).val();
                let storageId = $('#'+ this.$id('storages')).val();
                let rackId = $('#'+ this.$id('racks')).val();

                $('.loading-screen').addClass('active');
                axios.get('/manage/storage/warehouse/' + warehouseId + '/storage/' + storageId + '/rack/' + rackId + '/place', {
                    headers: {
                        'X-CSRF-TOKEN': this.csrf
                    },
                }).then(function (response) {
                    vue.storagePlaces = response.data;
                }).finally(function () {
                    $('.loading-screen').removeClass('active');
                });
            },
            sendRebook: function () {
                let warehouses = this.$refs[this.$id('warehouses')];
                let storages = this.$refs[this.$id('storages')];
                let racks = this.$refs[this.$id('racks')];
                let places = this.$refs[this.$id('places')];
                let quantity = parseInt(this.$refs[this.$id('quantity')].value);

                if( (parseInt(warehouses.value) < 0) ||
                    (parseInt(storages.value) < 0) ||
                    (parseInt(racks.value) < 0) ||
                    (parseInt(places.value) < 0) ||
                    (quantity <= 0)){
                    return;
                }

                $('.loading-screen').addClass('active');
                axios.post('/article/' + this.productId + '/storage/rebook', {
                        oldStoragePlaceId: this.storagePlaceId,
                        storagePlaceId: parseInt(places.value),
                        quantity: quantity
                }).then(function (data) {
                    vue.$emit('changedProduct', true);
                }).finally(function () {
                    $('.loading-screen').removeClass('active');
                })
            },
        }

    }
</script>

<style scoped>

</style>